import { useEffect } from 'react';
import { useMap, useMapEvents } from 'react-leaflet';

import type { LatLng } from 'leaflet';

type Props = {
  onLocationSelect: (latlng: LatLng) => void;
  disabled?: boolean;
};

export const MapEventsHandler = ({ disabled, onLocationSelect }: Props) => {
  const map = useMap();

  useEffect(() => {
    if (disabled) {
      map.dragging.disable();
      map.touchZoom.disable();
      map.doubleClickZoom.disable();
      map.scrollWheelZoom.disable();
      map.boxZoom.disable();
      map.keyboard.disable();

      return;
    }

    map.dragging.enable();
    map.touchZoom.enable();
    map.doubleClickZoom.enable();
    map.scrollWheelZoom.enable();
    map.boxZoom.enable();
    map.keyboard.enable();
  }, [disabled, map]);

  const handleMapClick = ({ latlng }: { latlng: LatLng }) => {
    if (disabled) {
      return;
    }

    onLocationSelect(latlng);
  };

  useMapEvents({
    click: handleMapClick,
  });

  return null;
};
